// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-Sidebar-Sidebar-module__DialogOpen";
var _2 = "webpack-components-shared-Sidebar-Sidebar-module__DialogOverlay";
var _3 = "webpack-components-shared-Sidebar-Sidebar-module__DialogPanel";
var _4 = "webpack-components-shared-Sidebar-Sidebar-module__DialogSurface";
var _5 = "webpack-components-shared-Sidebar-Sidebar-module__HeaderWithDivider";
var _6 = "webpack-components-shared-Sidebar-Sidebar-module__Panel";
var _7 = "webpack-components-shared-Sidebar-Sidebar-module__PanelActions";
var _8 = "webpack-components-shared-Sidebar-Sidebar-module__PanelContent";
var _9 = "webpack-components-shared-Sidebar-Sidebar-module__PanelFooter";
var _a = "webpack-components-shared-Sidebar-Sidebar-module__PanelHeader";
var _b = "webpack-components-shared-Sidebar-Sidebar-module__PanelTitle";
export { _1 as "DialogOpen", _2 as "DialogOverlay", _3 as "DialogPanel", _4 as "DialogSurface", _5 as "HeaderWithDivider", _6 as "Panel", _7 as "PanelActions", _8 as "PanelContent", _9 as "PanelFooter", _a as "PanelHeader", _b as "PanelTitle" }
